import React, { useState } from 'react';
import { Comment } from '../../lib/types/CommentTypes';

interface CommentableFieldProps {
  fieldId: string;
  clientId: string;
  author: 'client' | 'hailey';
  token?: string;
  password?: string;
  children: React.ReactNode;
  comments: Comment[];
  onCommentSubmit: () => void;
}

const CommentableField: React.FC<CommentableFieldProps> = ({ fieldId, clientId, author, token, password, children, comments, onCommentSubmit }) => {
  const [comment, setComment] = useState('');
  const [showComments, setShowComments] = useState(false);

  const handleCommentSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!comment.trim()) return;

    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (author === 'hailey' && password) {
      headers['X-Admin-Password'] = password;
    } else if (token) {
      headers['X-Client-Token'] = token;
    }

    try {
      await fetch('/api/comments', {
        method: 'POST',
        headers,
        body: JSON.stringify({
          clientId,
          author,
          fieldId,
          comment,
        }),
      });
      setComment('');
      onCommentSubmit();
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  const fieldComments = comments.filter(c => c.field_id === fieldId);

  return (
    <div className="relative mb-4">
      {children}
      <button onClick={() => setShowComments(!showComments)} className="absolute top-0 right-0 text-xs bg-gray-200 px-2 py-1 rounded">
        {showComments ? 'Hide' : 'Comments'} ({fieldComments.length})
      </button>
      {showComments && (
        <div className="mt-2 p-4 bg-gray-100 rounded">
          <div className="mb-4">
            {fieldComments.map((c: Comment) => (
              <div key={c.id} className={`mb-2 p-2 rounded ${c.author === 'hailey' ? 'bg-green-100' : 'bg-blue-100'}`}>
                <p className="font-bold">{c.author}</p>
                <p>{c.comment}</p>
                <p className="text-xs text-gray-500">{new Date(c.created_at).toLocaleString()}</p>
              </div>
            ))}
          </div>
          <form onSubmit={handleCommentSubmit}>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Add a comment..."
              className="w-full p-2 border rounded mb-2"
            />
            <button type="submit" className="bg-brand-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-brand-green-700">
              Submit Comment
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default CommentableField;
